export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/common-standard-service-stack-form';
